(function ($) {
    $(document).ready(function () {
        function getCookieValue(name)
        {
            const regex = new RegExp(`(^| )${name}=([^;]+)`)
            const match = document.cookie.match(regex)
            if (match) {
                return match[2]
            }
        }
        function setCookie(name, value, days) {
            let expires = "";
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
                expires = "expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + ";" + expires + ";path=/; domain=.trshealthcare.com;";
        }

        function createDropdown(data){
            const dropdown = `
                <div class="Login-dropdown" id="LoginDropdown">
                    <button type="button" class="Login-dropdown-trigger">
                        <img src="${data.photoUrl}" alt="${data.firstName} ${data.lastName} avatar" class="Login-dropdown-avatar" />
                        <div class="Login-dropdown-trigger-name">${data.firstName} ${data.lastName}</div>
                    </button>
                    <div class="Login-dropdown-content">
                        <div class="Login-dropdown-content-wrapper">
                            <a href="https://my.trshealthcare.com/dashboard">
                                <img src="${data.photoUrl}" alt="${data.firstName} ${data.lastName} avatar" class="Login-dropdown-avatar" /> 
                                My Dashboard
                            </a>
                            <a href="#" class="logout">
                                <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17 16L21 12M21 12L17 8M21 12L7 12M13 16V17C13 18.6569 11.6569 20 10 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H10C11.6569 4 13 5.34315 13 7V8" stroke="#374151" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                                </svg> 
                                Log Out 
                            </a>
                        </div>
                    </div>
                </div>
            `;

            return dropdown;
        }

        let hubData = getCookieValue('_hubData');
        let hpcToken = getCookieValue('_hcpLoginToken');
        setCookie('_hcpLoginToken', hpcToken, 9);

        if(getCookieValue('_hcpLoginToken') && hubData){
            $('.MainHeader-topbar .fl-button-group-buttons .fl-button-group-button').slice('-2').css('display', 'none');
            $('.MainHeader-topbar .fl-button-group-buttons').append(createDropdown(JSON.parse(hubData)));
        }
        $(document).on('click', '#LoginDropdown .Login-dropdown-trigger', function (){
            $('#LoginDropdown .Login-dropdown-content').toggle();
        });
        function clearCustomCookie() {
            document.cookie = '_hubData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.trshealthcare.com;';
            document.cookie = '_hcpLoginToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.trshealthcare.com;';
        }

        $(document).on('click', '#LoginDropdown .logout', function (){
            clearCustomCookie();
            location.reload();
        });
    });
})(jQuery);